import { render, staticRenderFns } from "./SponsoredPill.vue?vue&type=template&id=3807fe80&scoped=true"
import script from "./SponsoredPill.vue?vue&type=script&lang=ts&setup=true"
export * from "./SponsoredPill.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SponsoredPill.vue?vue&type=style&index=0&id=3807fe80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807fe80",
  null
  
)

export default component.exports